export default {
  unlocked_plural: '{{count}} offers have been unlocked',
  unlocked: '{{offer}} offers has been unlocked',
  removed_one: '{{offer}} offer has been removed',
  removed_other: '{{count}} have been removed',
};
